import Image from 'next/image';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

function UserDetailsHeader() {
    const { userDetails } = useContext(MPosContext);

    return (
        <Styles.Wrapper>
            <Styles.ProfileFlex>
                <Image
                    width={'60px'}
                    height={'60px'}
                    alt={''}
                    src={getImageBasePath('/images/profile.svg')}
                />
            </Styles.ProfileFlex>
            <Styles.UserDetailsFlex>
                <Styles.Name>{userDetails.name}</Styles.Name>
                <Styles.Phone>{userDetails.phone}</Styles.Phone>
            </Styles.UserDetailsFlex>
        </Styles.Wrapper>
    );
}

export default UserDetailsHeader;
